<template>
  <div class="container">
    <div class="header">
      <router-link to="/admage/addads">
        <el-button type="primary" size="small">
          <div style="display: flex; align-items: center;">
            <el-icon size="16">
              <Plus color="#fff" />
            </el-icon>
            <span> {{ $t('ad.addSchema') }} </span>
          </div>
        </el-button>
      </router-link>
    </div>
    <el-table :data="table.data" style="width: 100%" @sort-change="handleSortChange">
      <el-table-column prop="name" :label="$t('ad.name')">
        <template #default="{ row }">
          <div style="display: flex; justify-content: space-between;">
            <router-link style="color: #409eff;"
              :to="`/admage/${row.status === 0 ? 'editAds' : 'adsDetail'}?id=${row.id}`">{{ row.name }}</router-link>
            <el-tag v-if="row.status === 0" size="small">{{ $t('ad.draft') }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ad_play_time" :label="$t('ad.playTime')">
        <template #default="{ row }">
          <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ formatPlayTime(row.ad_play_time)
          }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="material_num" :label="$t('ad.materialNum')" />
      <el-table-column prop="robots" :label="$t('ad.robotNum')">
        <template #default="{ row }">
          <span>{{ row.robots?.length || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="start_time" :label="$t('ad.startTime')" sortable>
        <template #default="{ row }">
          <span v-if="row.status === 0">-</span>
          <span v-else>{{ timeFormat(row.start_time * 1000) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" :label="$t('ad.updateTime')" sortable>
        <template #default="{ row }">
          <span>{{ timeFormat(row.updated_at * 1000) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('ad.operation')" :width="180">
        <template #default="{ row }">
          <template v-if="row.status === 0">
            <router-link style="color: #409eff;" :to="`/admage/editAds?id=${row.id}`">{{
              $t('ad.edit') }}</router-link>
            <confirm :title="$t('ad.deleteDraft')" :message="$t('ad.deleteDraftWarningMessage')"
              @confirm="handleDelete(row)">
              <el-button style="color:#F5222D; margin-left: 10px; font-size: 14px;" type="text" size="small">
                {{ $t('ad.delete') }}
              </el-button>
            </confirm>
          </template>
          <router-link v-else style="color: #409eff;" :to="`/admage/editAds?id=${row.id}`">{{ $t('ad.copySchema')
          }}</router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" :background="true" v-show="table.total > 0" :page-size="table.pageSize"
      :total="table.total" :current-page="table.page" :page-sizes="[10, 20, 50]" @current-change="handlePageChange"
      @size-change="handleSizeChange" layout="total, prev, pager, next, sizes" />

    <el-dialog class="iv-dailog" v-model="dialog.visiable" :title="dialog.filename" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-image v-show="dialog.type === 'image'" style="vertical-align: bottom;" :src="dialog.url" fit="fill" />  

      <div style="width: 800px" v-show="dialog.type === 'video'">
        <video style="width: 800px; vertical-align: bottom;" controls :src="dialog.url"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { reactive, onMounted, defineComponent } from 'vue';
import Confirm from '@/components/confirm/confirm.vue'
import { getAdScheme, deleteAds } from '@/apis/ad'

import { ElMessage } from 'element-plus'
import { timeFormat } from '@/utils/format'
import i18n from "@/locales/index";
const _t = i18n.global.t;

export default defineComponent({
  components: { Confirm },
  setup() {
    const sortParams: { sort?: number } = { sort: -1 }
    const table = reactive({
      total: 0,
      page: 1,
      pageSize: 10,
      data: [] as any[],
    })

    const dialog = reactive({
      visiable: false,
      url: '',
      type: 'image',
      filename: '',
    })

    const formatPlayTime = (times: any[]) => {
      if (!Array.isArray(times)) return ''
      if (times.length === 1 && times[0].start_time === '00:00' && times[0].end_time === '00:00') {
        return _t('ad.allDay')
      }
      const result = times.map(item => `${item.start_time}~${item.end_time}`).filter(item => item !== '~')
      return result.join(', ')
    }

    const getTableList = () => {
      const { page, pageSize } = table
      getAdScheme({ page, pageSize, limit: true, status: -1, ...sortParams }).then((res: any) => {
        if (res.code === 200) {
          const { list, total } = res.data
          table.data = list
          table.total = total
        }
      })
    }

    const handleClose = () => {
      dialog.visiable = false
    }

    const handleDelete = (row: any) => {
      deleteAds(row.id).then((res: any) => {
        if (res.code === 200) {
          ElMessage.success(_t('ad.deleteSuccess'))
          getTableList()
        } else {
          ElMessage.error(res.msg)
        }
      })

    }

    const handlePageChange = (page: number) => {
      table.page = page
      getTableList()
    }

    const handleSizeChange = (pageSize: number) => {
      table.pageSize = pageSize
      table.page = 1
      getTableList()
    }

    const handleSortChange = (params: any) => {
      const { order, prop } = params
      if (prop === 'updated_at' && order === "ascending") sortParams.sort = 2
      if (prop === 'updated_at' && order === "descending") sortParams.sort = -2
      if (prop === "start_time" && order === "ascending") sortParams.sort = 1
      if (prop === "start_time" && order === "descending") sortParams.sort = -1
      if (!prop && !order) sortParams.sort = undefined
      getTableList()
    }

    onMounted(() => {
      getTableList()
    })

    return {
      table,
      dialog,
      formatPlayTime,
      handleClose,
      handleDelete,
      handlePageChange,
      handleSizeChange,
      timeFormat,
      handleSortChange,
    }
  }
})

</script>
 
<style scoped lang="scss">
.container {
  margin: 24px;
  background-color: #fff;
  min-height: 60vh;
  border-radius: 4px;
  padding: 24px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

:deep(.el-dialog__header) {
  text-align: center;
}

:deep(.el-dialog__body) {
  padding: 0;
}
</style>